import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Componente de dropdown que muestra favoritos en negrita
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.value - Valor seleccionado
 * @param {Function} props.onChange - Función a llamar cuando cambia la selección
 * @param {Array} props.options - Array de opciones [{id, name, isFavorite}]
 * @param {string} props.placeholder - Texto para la opción por defecto
 * @param {string} props.nameField - Nombre del campo a mostrar (por defecto: 'name')
 * @param {boolean} props.disabled - Si el dropdown está deshabilitado
 * @param {string} props.className - Clases CSS adicionales
 */
const FavoriteDropdown = ({
  value = '',
  onChange,
  options = [],
  placeholder = 'Seleccionar',
  nameField = 'name',
  disabled = false,
  className = '',
  ...props
}) => {
  // Determinar qué campo usar para mostrar el nombre
  const getDisplayField = (option) => {
    // Buscar el primer campo que termine con 'Name' o usar el especificado
    if (option[nameField]) return option[nameField];
    
    const nameKeys = Object.keys(option).filter(key => 
      key.endsWith('Name') || key === 'name' || key === 'size'
    );
    
    return nameKeys.length > 0 ? option[nameKeys[0]] : option.id;
  };

  return (
    <Form.Select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
      {...props}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option
          key={option.id}
          value={option.id}
          style={{ fontWeight: option.isFavorite ? 'bold' : 'normal' }}
        >
          {getDisplayField(option)}
        </option>
      ))}
    </Form.Select>
  );
};

export default FavoriteDropdown;